import React, { useEffect, useState } from 'react';
import { configs, downloadCSVData, formatCurrency, formatNumber } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import '../../../assets/styles/BuyOrder.css'
import { downloadCSVDoc, uploadCSVDoc } from '../../../services/apis/shareManagement/InventoryAPI';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import ToastPage from '../../includes/ToastPage';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import { DataGrid, GridToolbarContainer, GridToolbarExport, GridToolbar, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector } from '@material-ui/data-grid';
import BuyOrderModalPage from './BuyOrderModalPage';
import { Link } from 'react-router-dom';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import DeleteModalPage from '../../includes/DeleteModalPage';
import ConfirmModalPage from '../../includes/ConfirmModalPage';
import { getAllOrders, inventoryTracker } from '../../../services/apis/shareManagement/BuyOrdersApi';
import { useHistory } from 'react-router-dom';
import ErrorModalPage from '../../includes/ErrorModalPage';
import ManualPunchComponent from './ManualPunchComponent';
import OrderUpdateHistory from './OrderUpdateHistory';

export default function BuyOrderPage() {

    const { setKycRequesterUserDetail } = useKYCContext()
    const { setCurrModule, allowedFunc, showDelete, setShowDelete, showConfirm, setShowConfirm, getAllRemarkComments, setRemarkComments, logout, setLoginError, token, setShowSuccess } = useLogin()
    const { setOrderId, getOrdersByType, setUtrDetailModal, activeStatus, setActiveStatus, setDematTransferModal, setpayPendStatusModal, manuPayAckModal, setManualPayAckModal, getOrderDetailById, orderDetail, setOrderDetail, setHPApproveModal, setHPRejectModal, setHPRefundModal, setHPApproveQuantity, hpApprovePrice, setHPApprovePrice, hpApproveInstrument, setHPApproveInstrument, setUpdate, tableData, setTableData, downloadInvoiceByOrderId, downloadDealNoteByOrderId, downloadSPDSheetByOrderId, commentModal, setCommentModal, setUtrBreakupModal, setHPCompleteRefundModal, downloadHDFCSheetByOrderId, editManualPunch, setEditManualPunch, orderHistory, setOrderHistory, generateCashfreePaymentLinkByOrderId } = useBuyOrderContext()
    const { showError, setShowError, changeBeneficiaryStatus } = useKYCContext()

    const [selectionModel, setSelectionModel] = useState([]);

    var [count, setCount] = useState(0)
    const [confirmId, setConfirmId] = useState({})
    const [deleteId, setDeleteId] = useState({})
    const [error, setError] = useState("")
    const [rowsDisplay, setRowsDisplay] = useState(configs.defaultRowPerPage);
    const [page, setPage] = useState(configs.startPage);
    const [generatingLinkOrderId, setGeneratingLinkOrderId] = useState("")
    const [generatedCashfreeLinks, setGeneratedCashfreeLinks] = useState({})

    const history = useHistory()

    useEffect(() => {
        (async () => {
            if (activeStatus && configs.shareStatusTypes[activeStatus] && page) {
                setRemarkComments([])
                setSelectionModel([])
                setEditManualPunch(false)
                setOrderHistory(false)
                if (page > configs.startPage) {
                    setPage(configs.startPage)
                }
                else {
                    await getOrdersByType(configs.shareStatusTypes[activeStatus].api, page, configs.recordPerPage, true);
                }
            }
        })()
        return () => {
            setEditManualPunch(false)
            setOrderHistory(false)
        }
    }, [activeStatus])

    useEffect(() => {
        (async () => {
            try {
                if (activeStatus && configs.shareStatusTypes[activeStatus] && page)
                    await getOrdersByType(configs.shareStatusTypes[activeStatus].api, page, configs.recordPerPage);
            } catch (error) {
                console.error(error);
            }
        })();
    }, [page])

    useEffect(() => {
        if (allowedFunc.includes(configs.functionList['buy_module:load_all_buy_orders'])) {
            setCurrModule(configs.modules.smBuyOrder);
            setActiveStatus(Object.keys(configs.shareStatusTypes)[0]);
        } else {
            return history.goBack()
        }
    }, [])

    // get order detail 
    async function getOrderDetail(orderId) {
        try {
            let response = await getOrderDetailById(orderId)
            if (response.success) {
                setOrderDetail(response.data)
            } else {
                setOrderDetail("")
            }
        } catch (error) {

        }
    }

    // download inventory tracking sheet
    async function inventoryTrackerDownload() {
        try {
            let response = await inventoryTracker(token);
            if (response && response.status === 200) {
                let a = document.createElement("a"); //Create <a>
                a.href = response.data; //Image Base64 Goes here
                a.download = `Inventory Tracker.csv`; //File name Here
                a.click();
                return "success"
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                setError(response.data.error)
                setShowError(true)
            }
        } catch (error) {
            console.error(error);

        }
    }

    // export all orders CSV
    async function exportAllOrder() {
        try {
            let response = await getAllOrders(token);
            if (response && response.status === 200) {
                downloadCSVData(response.data, "All Orders");
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
        } catch (error) {

        }
    }


    // columns for various data tables
    function extractCashfreeLink(data) {
        if (!data) return ""
        if (typeof data === "string" && data.startsWith("http")) return data
        if (typeof data === "object") {
            return data.link_url || data.payment_link || data.paymentLink || data.link || data.url || ""
        }
        return ""
    }

    function getCashfreeLinkForRow(row) {
        if (!row) return ""
        return generatedCashfreeLinks[row.id] || row.link_url || ""
    }

    async function copyTextToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)
            return
        }
        const ta = document.createElement("textarea")
        ta.value = text
        ta.setAttribute("readonly", "")
        ta.style.position = "fixed"
        ta.style.left = "-9999px"
        document.body.appendChild(ta)
        ta.select()
        try {
            document.execCommand("copy")
        } finally {
            document.body.removeChild(ta)
        }
    }

    async function copyCashfreeLink(link) {
        try {
            if (!link) {
                setError("No payment link available to copy.")
                setShowError(true)
                return
            }
            await copyTextToClipboard(link)
            setShowSuccess(true)
        } catch (error) {
            setError("Unable to copy payment link.")
            setShowError(true)
        }
    }

    async function generateCashfreeLink(orderId) {
        try {
            setGeneratingLinkOrderId(orderId)
            const response = await generateCashfreePaymentLinkByOrderId(orderId)
            if (response && response.success) {
                const generatedLink = extractCashfreeLink(response.data)
                if (generatedLink) {
                    setGeneratedCashfreeLinks((prev) => ({ ...prev, [orderId]: generatedLink }))
                    await copyCashfreeLink(generatedLink)
                } else {
                    setShowSuccess(true)
                }
                await getOrdersByType(configs.shareStatusTypes[activeStatus].api, configs.startPage, configs.allRecordsFetchedTillNow, true);
            } else {
                setError(response || "Unable to generate payment link.")
                setShowError(true)
            }
        } catch (error) {
            console.error(error)
            setError("Unable to generate payment link.")
            setShowError(true)
        } finally {
            setGeneratingLinkOrderId("")
        }
    }

    const columns = [
        {
            field: "id", headerName: "Order ID", minWidth: 50, flex: 0.4, renderCell: (params) => {
                return <a href='' onClick={(e) => {
                    e.preventDefault();
                    getOrderDetail(params.row.id)
                    setOrderHistory(true)
                }}>{params.row.id}</a>
            }, valueGetter: (params) => {
                return params.row.id
            }
        },
        { field: "company_name", headerName: "Company Name", minWidth: 200, flex: 0.5, cellClassName: "break-text f-12" },
        {
            field: "name", headerName: "Name", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.name
            }
        },
        {
            field: "mobile", headerName: "Phone No.", minWidth: 100, flex: 0.3, cellClassName: "break-text f-12", renderCell: (params) => {
                return <a href={"https://wa.me/" + params.row.user.mobile} target="_blank">{params.row.user.mobile ? `+${params.row.user.mobile}` : params.row.user.mobile}</a>
            }, valueGetter: (value) => value.row.user.mobile ? `+${value.row.user.mobile}` : value.row.user.mobile
        },
        {
            field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                    return <Link to={`/customerProfile/${params.row.user.id}`} onClick={() => {
                        setKycRequesterUserDetail(params.row.user)
                    }}>{params.row.user.email}</Link>
                } else {
                    return params.row.user.email
                }
            }, valueGetter: (value) => value.row.user.email
        },
        {
            field: "is_beneficiary_added", headerName: "Beneficiary Added", minWidth: 200, flex: 0.5, hide: activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name || activeStatus === configs.shareStatusTypes["Refund Initiated"].name ? false : true, cellClassName: "break-text", renderCell: (params) => {
                return <input type="checkbox" id="ben_add" name="ben_add" checked={params.row.user.is_beneficiary_added} onChange={async (e) => {
                    e.preventDefault();
                    let response = await changeBeneficiaryStatus(params.row.user.id, e.target.checked);
                    if (response) {
                        await getOrdersByType(configs.shareStatusTypes[activeStatus].api, configs.startPage, configs.allRecordsFetchedTillNow, true);
                        setShowSuccess(true);
                    } else {
                        setShowError(true);
                    }
                }} />
            }, valueGetter: (params) => params.row.user.is_beneficiary_added ? "Yes" : "No"
        },
        {
            field: "pan_number", headerName: "Pan Number", minWidth: 100, flex: 0.4, hide: activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name ? false : true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.pan_number
            }
        },
        {
            field: "account_no", headerName: "Account No.", minWidth: 150, flex: 0.4, hide: true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.bank_account_number
            }
        },
        {
            field: "bank_name", headerName: "Bank Name", minWidth: 150, flex: 0.4, hide: true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.bank_name
            }
        },
        {
            field: "ifsc", headerName: "IFSC", minWidth: 150, flex: 0.4, hide: true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.bank_ifsc_code
            }
        },
        {
            field: "dp_id", headerName: "DP ID", minWidth: 100, flex: 0.4, hide: activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name ? false : true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.dp_id
            }
        },
        {
            field: "client_id", headerName: "Client ID", minWidth: 100, flex: 0.4, hide: activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name ? false : true, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.user.client_id
            }
        },
        {
            field: "distributor", headerName: "Distributor", minWidth: 200, flex: 0.5, hide: true, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user && params.row.user.distributor && params.row.user.distributor.name ? params.row.user && params.row.user.distributor && params.row.user.distributor.name : ""
            }, valueGetter: (params) => params.row.user && params.row.user.distributor && params.row.user.distributor.name ? params.row.user && params.row.user.distributor && params.row.user.distributor.name : ""
        },
        {
            field: "utm", headerName: "UTM", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user && params.row.user.distributor && params.row.user.distributor.utm ? params.row.user && params.row.user.distributor && params.row.user.distributor.utm : ""
            }, valueGetter: (params) => params.row.user && params.row.user.distributor && params.row.user.distributor.utm ? params.row.user && params.row.user.distributor && params.row.user.distributor.utm : ""
        },
        {
            field: "utm_recorded_from", headerName: "UTM Recorded From", minWidth: 200, flex: 0.5, hide: true, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user && params.row.user.distributor && params.row.user.distributor.utm_recorded_from ? params.row.user && params.row.user.distributor && params.row.user.distributor.utm_recorded_from : ""
            }, valueGetter: (params) => params.row.user && params.row.user.distributor && params.row.user.distributor.utm_recorded_from ? params.row.user && params.row.user.distributor && params.row.user.distributor.utm_recorded_from : ""
        },
        {
            field: "rm_email", headerName: "RM Email", minWidth: 100, flex: 0.5, hide: true, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.email ? params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.email : ""
            }, valueGetter: (params) => params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.email ? params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.email : ""
        },
        {
            field: "rm_name", headerName: "RM Name", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.name ? params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.name : ""
            }, valueGetter: (params) => params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.name ? params.row.user && params.row.user.relationship_manager && params.row.user.relationship_manager.name : ""
        },
        {
            field: "deal_done_by", headerName: "Deal Done By", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.deal_done_by && params.row.deal_done_by.name ? params.row.deal_done_by.name : ""
            }, valueGetter: (params) => params.row.deal_done_by && params.row.deal_done_by.name ? params.row.deal_done_by.name : ""
        },
        { field: "order_time", headerName: "Order Time", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12" },
        {
            field: "quantity", headerName: "Quantity", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return formatNumber(parseInt(params.row.quantity))
            }
        },
        {
            field: "price_per_share", headerName: "Price/Share", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return <>{formatCurrency(parseFloat(params.row.price_per_share))}
                    {params.row.price_per_share && params.row.old_order_price && (params.row.price_per_share !== (params.row.old_order_price / (params.row.old_order_quantity ? params.row.old_order_quantity : params.row.quantity))) ?
                        <div id={`tooltip${params.row.id}`}>
                            <i className="fa fa-info-circle curPoint pl-2 text-primary" aria-hidden="true" onClick={(e) => {
                                e.preventDefault();
                                document.getElementById(`tooltip${params.row.id}`).getElementsByClassName("tooltipBox")[0].style.display = 'block'
                            }} />
                            <div className='tooltipBox card'>
                                <div className="priceSlab">
                                    <p className='my-1'><b>Order Rate Update</b></p>
                                    <p className='text-right text-danger curPoint my-1' onClick={(e) => {
                                        e.preventDefault();
                                        document.getElementById(`tooltip${params.row.id}`).getElementsByClassName("tooltipBox")[0].style.display = 'none'
                                    }}><b>X</b></p>
                                </div>
                                <div className='mb-1'>Current Rate: {formatCurrency(parseFloat(params.row.price_per_share))}</div>
                                <div className='m-0'>Old Rate: {formatCurrency(parseFloat(params.row.old_order_price / (params.row.old_order_quantity ? params.row.old_order_quantity : params.row.quantity)))}</div>
                            </div>
                        </div> : null}
                </>
            }, valueGetter: (value) => value.row.price_per_share
        },
        {
            field: "regular_commission", headerName: "Commission", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.regular_commission))
            }, valueGetter: (value) => value.row.regular_commission
        },
        {
            field: "price_net_of_upmark_or_commission", headerName: "Price net of upmark or Commission", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.price_net_of_upmark_or_commission))
            }, valueGetter: (value) => value.row.price_net_of_upmark_or_commission
        },
        {
            field: "current_price_per_share", headerName: "Portal Price/Share", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.current_price_per_share))
            }, valueGetter: (value) => value.row.current_price_per_share
        },
        {
            field: "price_change_perc", headerName: "Price Change %", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return `${formatNumber(parseFloat(params.row.price_change_perc))}%`
            }, valueGetter: (value) => value.row.price_change_perc
        },
        {
            field: "price", headerName: "Price", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.price))
            }, valueGetter: (value) => value.row.price
        },
        {
            field: "total_tds", headerName: "Total TDS", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.total_tds))
            }, valueGetter: (value) => value.row.total_tds
        },
        {
            field: "total_tcs", headerName: "Total TCS", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.total_tcs))
            }, valueGetter: (value) => value.row.total_tcs
        },
        {
            field: "referral_bonus", headerName: "Referral Bonus", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.referral_bonus))
            }, valueGetter: (value) => value.row.referral_bonus
        },
        {
            field: "coupon_code", headerName: "Coupon Code", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12"
        },
        {
            field: "coupon_discount", headerName: "Coupon Discount", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.coupon_discount))
            }, valueGetter: (value) => value.row.coupon_discount
        },
        {
            field: "amount_to_be_paid", headerName: "Payable Amount", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.amount_to_be_paid))
            }, valueGetter: (value) => value.row.amount_to_be_paid
        },
        {
            field: "amount_to_be_paid_with_tds_tcs", headerName: "Amount With TDS/TCS", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.amount_to_be_paid_with_tds_tcs))
            }, valueGetter: (value) => value.row.amount_to_be_paid_with_tds_tcs
        },
        ...(activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name || activeStatus === configs.shareStatusTypes["Delivery Made"].name ? [{
            field: "payment_mode", headerName: "Payment Mode", minWidth: 150, flex: 0.4, cellClassName: "break-text text-capitalize f-12", renderCell: (params) => {
                return <p>{params.row.payment_mode} {params.row.payment_mode === "manual" ? <i className="fa fa-info-circle curPoint text-primary" onClick={(e) => {
                    e.preventDefault();
                    setOrderId(params.row.id)
                    getOrderDetail(params.row.id)
                    setUtrBreakupModal(true)
                    setHPApproveInstrument(params.row.company_name)
                }}></i> : null}</p>
            }, valueGetter: (value) => value.row.payment_mode
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name || activeStatus === configs.shareStatusTypes["Delivery Made"].name ? [{
            field: "payment_ref_number", headerName: "Payment Ref. No.", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.payment_details.payment_ref_number
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name || activeStatus === configs.shareStatusTypes["Delivery Made"].name ? [{
            field: "utr_bank_name", headerName: "Manual Payment Bank", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
                return params.row.payment_details.utr_bank_name
            }
        }] : []),
        { field: "order_payment_time", headerName: "Payment Time", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12" },
        ...(activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name ? [{
            field: "is_back_from_dm_to_ack", headerName: "Back from DM", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return params.row.is_back_from_dm_to_ack ? "Yes" : "No"
            }, valueGetter: (value) => value.row.is_back_from_dm_to_ack ? "Yes" : "No"
        }] : []),
        {
            field: "upmark", headerName: "Upmark", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.upmark))
            }, valueGetter: (value) => value.row.upmark
        },
        {
            field: "upmark_final_pay", headerName: "Upmark Final Pay", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return formatCurrency(parseFloat(params.row.upmark_final_pay))
            }, valueGetter: (value) => value.row.upmark_final_pay
        },
        {
            field: "allow_regular_commission", headerName: "Regular Commission", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return params.row.allow_regular_commission ? "Yes" : "No"
            }, valueGetter: (value) => value.row.allow_regular_commission ? "Yes" : "No"
        },
        {
            field: "distributor_commission_percentage", headerName: "Commission Percentage", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                return params.row.regular_commission ? formatNumber(parseFloat(params.row.regular_commission / params.row.price * 100)) + "%" : "-"
            }, valueGetter: (value) => value.row.regular_commission ? (parseFloat(value.row.regular_commission) / parseFloat(value.row.price) * 100).toFixed(2) + "%" : "0%"
        },
        { field: "status", headerName: "Status", minWidth: 150, flex: 0.4, cellClassName: "break-text text-capitalize f-12" },
        {
            field: "comment", headerName: "Comment", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return <div>{params.row.user.comment && params.row.user.comment.text ? params.row.user.comment.text : ""}<i className='ml-2 fas fa-edit text-primary curPoint' onClick={(e) => {
                    setOrderId(params.row.id)
                    setCommentModal(true)
                }} /></div>
            }, valueGetter: (params) => params.row.user.comment && params.row.user.comment.text ? params.row.user.comment.text : ""
        },
        {
            field: "comment_name", headerName: "Commenter Name", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user.comment && params.row.user.comment.commenter && params.row.user.comment.commenter.name ? params.row.user.comment.commenter.name : ""
            }, valueGetter: (params) => params.row.user.comment && params.row.user.comment.commenter && params.row.user.comment.commenter.name ? params.row.user.comment.commenter.name : ""
        },
        {
            field: "comment_date", headerName: "Comment Timestamp", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.user.comment && params.row.user.comment.timestamp ? params.row.user.comment.timestamp : ""
            }, valueGetter: (params) => params.row.user.comment && params.row.user.comment.timestamp ? params.row.user.comment.timestamp : ""
        },
        {
            field: "allow_advance_dealer_delivery", headerName: "Advance Delivery", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
                return params.row.allow_advance_dealer_delivery ? "Yes" : "No"
            }, valueGetter: (params) => params.row.allow_advance_dealer_delivery ? "Yes" : "No"
        },
        ...(activeStatus === configs.shareStatusTypes["Completed Orders"].name || activeStatus === configs.shareStatusTypes["Refund Completed Orders"].name ? [{
            field: "download", headerName: "Invoice", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                return <a href="#" className="custom-link text-primary" onClick={(e) => {
                    e.preventDefault()
                    downloadInvoiceByOrderId(cellValues.row.id)
                }}>Download</a>
            }
        }, {
            field: "dealNote", headerName: "Deal Note", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                return <a href="#" className="custom-link text-primary" onClick={(e) => {
                    e.preventDefault()
                    downloadDealNoteByOrderId(cellValues.row.id)
                }}>Download</a>
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Payment Pending"].name || activeStatus === configs.shareStatusTypes["Acknowledgement Pending"].name ? [{
            field: "dealNote", headerName: "Deal Note", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                return <a href="#" className="custom-link text-primary" onClick={(e) => {
                    e.preventDefault()
                    downloadDealNoteByOrderId(cellValues.row.id)
                }}>Download</a>
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Rejected Orders"].name ? [{
            field: "delete", headerName: "Delete", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:delete_buy_order'])) {
                    return <a href="#" className="custom-link text-danger" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        setDeleteId({
                            "category": configs.modules.smBuyOrder,
                            "type": "Order",
                            "name": cellValues.row.id,
                            "id": cellValues.row.id
                        })
                        setShowDelete(true)
                    }}>Delete</a>
                } else {
                    return "Delete"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Deleted Orders"].name ? [{
            field: "restore", headerName: "Restore", minWidth: 70, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:restore_buy_order'])) {
                    return <a href="#" className="custom-link text-primary" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        setShowConfirm(true)
                        setConfirmId({
                            "category": configs.modules.smBuyOrder,
                            "type": "Order",
                            "name": cellValues.row.id,
                            "id": cellValues.row.id
                        })
                    }}>Restore</a>
                } else {
                    return "Restore"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Payment Pending"].name || activeStatus === configs.shareStatusTypes["Acknowledgement Pending"].name || activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name || activeStatus === configs.shareStatusTypes["Intervention Needed"].name ? [{
            field: "reject", headerName: "Reject", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:reject_buy_order'])) {
                    return <a href="#" className="custom-link text-danger" onClick={(e) => {
                        e.preventDefault()
                        getAllRemarkComments(configs.remarkCategories['buy_module:payment_pending'])
                        setOrderId(cellValues.row.id)
                        setHPApproveInstrument(cellValues.row.company_name)
                        setHPRejectModal(true)
                    }}>Reject</a>
                } else {
                    return "Reject"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Payment Pending"].name || activeStatus === configs.shareStatusTypes["Acknowledgement Pending"].name ? [{
            field: "edit", headerName: "Edit", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:update_buy_order'])) {
                    return <a href="#" className="custom-link text-primary" onClick={(e) => {
                        e.preventDefault()
                        setEditManualPunch(cellValues.row)
                    }}>Edit</a>
                } else {
                    return "Edit"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Payment Pending"].name ? [{
            field: "generateCashfreeLink", headerName: "Cashfree Link", minWidth: 140, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                const link = getCashfreeLinkForRow(cellValues.row)
                if (link) {
                    return <a href="#" className="custom-link text-primary" onClick={(e) => {
                        e.preventDefault()
                        copyCashfreeLink(link)
                    }}>Copy link</a>
                }
                return <a href="#" className="custom-link text-primary" onClick={(e) => {
                    e.preventDefault()
                    if (generatingLinkOrderId !== cellValues.row.id) {
                        generateCashfreeLink(cellValues.row.id)
                    }
                }}>{generatingLinkOrderId === cellValues.row.id ? "Generating..." : "Generate Link"}</a>
            }
        }, {
            field: "payment", headerName: "Payment", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:manual_payment_processing_of_buy_order'])) {
                    return <a href="#" className="custom-link" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        setUtrDetailModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>Payment</a>
                } else {
                    return "Payment"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Acknowledgement Pending"].name ? [{
            field: "review", headerName: "Review", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:acknowledge_manual_payment_of_buy_order'])) {
                    return <a href="#" className="custom-link" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        getOrderDetail(cellValues.row.id)
                        setManualPayAckModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>Review</a>
                } else {
                    return "Review"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Share Transfer Pending"].name ? [{
            field: "refund", headerName: "Refund", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:initiate_refund'])) {
                    return <a href="#" className="custom-link text-primary" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        setHPRefundModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>Refund</a>
                } else {
                    return "Refund"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Dealer Payment Pending"].name || activeStatus === configs.shareStatusTypes["Delivery Made"].name ? [{
            field: "completeDelivery", headerName: "Complete Delivery", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:transfer_shares_of_buy_order']) || allowedFunc.includes(configs.functionList['buy_module:acknowledge_manual_payment_of_buy_order']) || allowedFunc.includes(configs.functionList['buy_module:mark_order_as_dealer_payment_pending'])) {
                    return <a href="#" className="custom-link text-success" onClick={(e) => {
                        e.preventDefault()
                        getAllRemarkComments(configs.remarkCategories['buy_module:share_delivered'])
                        setOrderId(cellValues.row.allow_advance_dealer_delivery && activeStatus === configs.shareStatusTypes["Delivery Made"].name ? { id: cellValues.row.id, moveToSTP: 2 } : cellValues.row.id)
                        setDematTransferModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>{cellValues.row.allow_advance_dealer_delivery && activeStatus === configs.shareStatusTypes["Delivery Made"].name ? "Move to DPP" : "Complete Delivery"}</a>
                } else {
                    return cellValues.row.allow_advance_dealer_delivery && activeStatus === configs.shareStatusTypes["Delivery Made"].name ? "Move to DPP" : "Complete Delivery"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Refund Initiated"].name ? [{
            field: "completRefund", headerName: "Complete Refund", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:complete_refund'])) {
                    return <a href="#" className="custom-link text-success" onClick={(e) => {
                        e.preventDefault()
                        getAllRemarkComments(configs.remarkCategories['buy_module:share_delivered'])
                        setOrderId(cellValues.row.id)
                        setHPCompleteRefundModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>Complete Refund</a>
                } else {
                    return "Complete Refund"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Intervention Needed"].name ? [{
            field: "approve", headerName: "Approve", minWidth: 70, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:approve_intervention_needed_buy_order'])) {
                    return <a href="#" className="custom-link text-success" onClick={(e) => {
                        e.preventDefault()
                        setOrderId(cellValues.row.id)
                        setHPApproveQuantity(cellValues.row.quantity)
                        setHPApprovePrice(cellValues.row.price_per_share)
                        setHPApproveInstrument(cellValues.row.company_name)
                        setHPApproveModal(true)
                    }}>Approve</a>
                } else {
                    return "Approve"
                }
            }
        }] : []),
        ...(activeStatus === configs.shareStatusTypes["Delivery Made"].name ? [{
            field: "moveToSTP", headerName: "Move to STP", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
                if (allowedFunc.includes(configs.functionList['buy_module:acknowledge_manual_payment_of_buy_order'])) {
                    return <a href="#" className="custom-link text-danger" onClick={(e) => {
                        e.preventDefault()
                        getAllRemarkComments(configs.remarkCategories['buy_module:share_delivered'])
                        setOrderId({ id: cellValues.row.id, moveToSTP: true })
                        setDematTransferModal(true)
                        setHPApproveInstrument(cellValues.row.company_name)
                    }}>Move to STP</a>
                } else {
                    return "Move to STP"
                }
            }
        }] : [])
    ]


    // download hdfc sheet
    async function exportSPD() {
        try {
            let ele = document.getElementById('buyOrderContainer').click();
            let response = await downloadSPDSheetByOrderId(selectionModel)
            if (response && response === "success") {
                setSelectionModel([])
            } else {
                setError(response)
                setShowError(true)
            }
        } catch (error) {
            console.error(error)
        }
    }

    // add hdfc export option in export toolbar
    function addSPDExportButton() {
        try {
            setTimeout(() => {
                // get root element to add element
                let ele = document.getElementsByClassName("MuiList-root MuiDataGrid-gridMenuList MuiList-padding")
                if ((ele.length > 0) && (selectionModel.length > 0) && (activeStatus === configs.shareStatusTypes['Share Transfer Pending'].name)) {
                    //create new element to add
                    var li = document.createElement('li')
                    li.className = "MuiButtonBase-root MuiListItem-root MuiMenuItem-root MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button";
                    let span = document.createElement('span');
                    span.className = "MuiTouchRipple-root"
                    li.appendChild(document.createTextNode("SPD Sheet"))
                    li.appendChild(span)
                    li.tabIndex = 0
                    li.setAttribute("role", "menu-item")
                    li.ariaDisabled = "false"
                    li.addEventListener("click", exportSPD);

                    //add new elemet to parent
                    ele[0].appendChild(li)
                }
            }, 200)
        } catch (error) {
            console.error(error)
        }
    }

    // download hdfc sheet
    async function exportHDFC() {
        try {
            let ele = document.getElementById('buyOrderContainer').click();
            let response = await downloadHDFCSheetByOrderId(selectionModel)
            if (response && response === "success") {
                setSelectionModel([])
            } else {
                setError(response)
                setShowError(true)
            }
        } catch (error) {
            console.error(error)
        }
    }

    // add hdfc export option in export toolbar
    function addHDFCExportButton() {
        try {
            setTimeout(() => {
                // get root element to add element
                let ele = document.getElementsByClassName("MuiList-root MuiDataGrid-gridMenuList MuiList-padding")
                if ((ele.length > 0) && (selectionModel.length > 0) && (activeStatus === configs.shareStatusTypes["Refund Initiated"].name)) {
                    //create new element to add
                    var li = document.createElement('li')
                    li.className = "MuiButtonBase-root MuiListItem-root MuiMenuItem-root MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button";
                    let span = document.createElement('span');
                    span.className = "MuiTouchRipple-root"
                    li.appendChild(document.createTextNode("HDFC Sheet"))
                    li.appendChild(span)
                    li.tabIndex = 0
                    li.setAttribute("role", "menu-item")
                    li.ariaDisabled = "false"
                    li.addEventListener("click", exportHDFC);

                    //add new elemet to parent
                    ele[0].appendChild(li)
                }
            }, 200)
        } catch (error) {
            console.error(error)
        }
    }

    // react data table export option
    function CustomToolbar() {
        try {
            let ele = document.querySelectorAll("[aria-label^='Export']");
            if (ele.length > 0 && activeStatus === configs.shareStatusTypes['Share Transfer Pending'].name) {
                ele[0].addEventListener("click", addSPDExportButton)
            } else if (ele.length > 0) {
                ele[0].addEventListener("click", addHDFCExportButton)
            }
        } catch (error) {
            console.error(error)
        }
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport csvOptions={{ allColumns: true }} />
            </GridToolbarContainer>
        );
    }

    // buy order ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                {editManualPunch ? <ManualPunchComponent /> : orderHistory ? <OrderUpdateHistory /> :
                    <div id='buyOrderContainer' className="smbo-container">
                        <div style={{ width: "100%" }}>
                            <div className="row mx-md-4 mx-2 my-2 p-0">
                                <div className="col-md-8 m-0 p-0">
                                    <div className='row m-0 mb-2 p-0'>
                                        <div className='col-6 p-0'>
                                            <p className="h5 text-custom-grey">{activeStatus}</p>
                                        </div>
                                        <div className='col-3 p-0 text-right'>
                                            <button className="btn btn-primary" onClick={(e) => {
                                                e.preventDefault()
                                                exportAllOrder();
                                            }}>Export All Orders</button>
                                        </div>
                                        <div className='col-3 p-0 text-right'>
                                            <button className="btn btn-primary" onClick={(e) => {
                                                e.preventDefault()
                                                inventoryTrackerDownload();
                                            }}>Inventory Tracker</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 text-md-right text-left m-0 p-0">
                                    <span className="text-primary mr-2">Status</span>
                                    <select name="" id="" className=" py-1 px-2 border rounded" value={activeStatus ? activeStatus : ""} onChange={(e) => {
                                        setActiveStatus(e.target.value)
                                        setTableData("")
                                    }}>
                                        {Object.keys(configs.shareStatusTypes).map((element, key) => {
                                            if (allowedFunc.includes(configs.shareStatusTypes[element].functionName)) {
                                                return (
                                                    <option key={`shareStatusKey` + key} value={configs.shareStatusTypes[element].name}>{configs.shareStatusTypes[element].name}</option>
                                                )
                                            } else {
                                                return null
                                            }
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="kyc-table">
                                {tableData ? <DataGrid
                                    rows={tableData}
                                    columns={columns}
                                    resizable={true}
                                    pageSize={rowsDisplay}
                                    pagination
                                    headerHeight={30}
                                    rowHeight={40}
                                    onPageChange={(currenIndex) => {
                                        if ((currenIndex + 1) === Math.ceil(tableData.length / rowsDisplay)) {
                                            setPage(page + 1);
                                        }
                                    }}
                                    onPageSizeChange={(rowsBeingDisplayed) => {
                                        setRowsDisplay(rowsBeingDisplayed);
                                    }}
                                    checkboxSelection={activeStatus === configs.shareStatusTypes['Share Transfer Pending'].name || activeStatus === configs.shareStatusTypes['Refund Initiated'].name ? true : false}
                                    onSelectionModelChange={(newSelectionModel) => {
                                        if (activeStatus === configs.shareStatusTypes['Share Transfer Pending'].name || activeStatus === configs.shareStatusTypes['Refund Initiated'].name) {
                                            setSelectionModel(newSelectionModel);
                                            let ele = document.getElementById('buyOrderContainer').click();
                                        }
                                    }}
                                    selectionModel={activeStatus === configs.shareStatusTypes['Share Transfer Pending'].name || activeStatus === configs.shareStatusTypes['Refund Initiated'].name ? selectionModel : []}
                                    components={{
                                        Toolbar: CustomToolbar,
                                    }}
                                />
                                    : <div className="loader"></div>}
                            </div>
                        </div>
                    </div>}
                <BuyOrderModalPage />
                <ToastPage />
                <ErrorModalPage error={error} />
                {showDelete ? <DeleteModalPage {...deleteId} /> : showConfirm ? <ConfirmModalPage {...confirmId} /> : null}
            </div>
        </>
    )
}